// SSC-95 (E8.7): the SecureScale manager pages, mounted under /securescale/*.
//
// The package is pinned to an exact reviewed securitydb commit in package.json.
// Registry publication and deployment remain separate acceptance gates.
import { createManagerClient, type SecureScaleManagerClient } from '@securescale/admin-pages';
import { apiClient } from '@/lib/api-client';

/**
 * The manager client over BOS's own authenticated axios client, so every
 * request carries the session token and goes to `/securescale/manage/*`
 * under the API base, where BOS's forwarder applies the entitlement and
 * the permissions.
 */
export const securescaleClient: SecureScaleManagerClient = createManagerClient(apiClient);
